/*
  CTA split-media responsive image swapping — extracted from
  sections/cta-split-media-with-text.liquid so it ships from a cacheable, deferred asset instead
  of inline script.

  The section id was baked into the root lookup; the work now runs per `[data-cta-split-media]`
  root (a marker attribute added to this section's own root — `data-section-type` alone is
  shared with other media-with-text sections) and is guarded by data-cta-split-init so repeat
  calls are no-ops.
*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cta-split-media]').forEach(initSection);
});

function initSection(sectionRoot) {
  if (!sectionRoot || sectionRoot.dataset.ctaSplitInit === '1') return;
  sectionRoot.dataset.ctaSplitInit = '1';

  let wasMobile = window.innerWidth <= 767.98;

  function setNaturalRatio() {
    if (!sectionRoot.classList.contains('media-with-text--shape-natural')) return;

    sectionRoot.querySelectorAll('.media-with-text__media').forEach((box) => {
      const styles = getComputedStyle(box);
      const desktopPad = styles.getPropertyValue('--ar-padding-desktop').trim();
      const mobilePad = styles.getPropertyValue('--ar-padding-mobile').trim();

      if (window.innerWidth <= 767.98) {
        if (mobilePad) box.style.setProperty('--ar-padding', mobilePad);
      } else {
        if (desktopPad) box.style.setProperty('--ar-padding', desktopPad);
      }
    });
  }

  function hydrateImage(img) {
    if (!img) return;

    const dataSrc = img.getAttribute('data-src');
    const dataSrcset = img.getAttribute('data-srcset');

    if ((!img.getAttribute('src') || img.getAttribute('src') === '') && dataSrc) {
      img.setAttribute('src', dataSrc);
    }

    if ((!img.getAttribute('srcset') || img.getAttribute('srcset') === '') && dataSrcset) {
      img.setAttribute('srcset', dataSrcset);
    }

    img.classList.add('loaded');
  }

  function refreshVisibleImage() {
    const isMobile = window.innerWidth <= 767.98;
    const selector = isMobile
      ? '.background-image.mobile-only img'
      : '.background-image.desktop-only img';

    sectionRoot.querySelectorAll(selector).forEach(hydrateImage);
  }

  function onResize() {
    const isMobile = window.innerWidth <= 767.98;

    setNaturalRatio();

    if (isMobile !== wasMobile) {
      wasMobile = isMobile;

      setTimeout(() => {
        refreshVisibleImage();
        setNaturalRatio();
      }, 50);
    }
  }

  sectionRoot.querySelectorAll('.video-container video').forEach((video) => {
    video.addEventListener('loadedmetadata', () => {
      const ar = video.videoWidth / video.videoHeight;
      const pad = (100 / ar) + '%';
      const box = video.closest('.media-with-text__media');
      if (box) box.style.setProperty('--ar-padding', pad);
    }, { once: true });
  });

  setNaturalRatio();
  refreshVisibleImage();

  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', onResize);
  document.addEventListener('shopify:section:reorder', onResize);
  document.addEventListener('shopify:block:select', onResize);
}
